import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { Marketdate } from './marketdate.model';
import { MarketdateService } from './marketdate.service';
@Injectable()
export class MarketdatePopupService {
    private isOpen = false;
    constructor(
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private marketdateService: MarketdateService

    ) {}

    open(component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.marketdateService.find(id).subscribe((marketdate) => {
                marketdate.originalDate = this.datePipe
                    .transform(marketdate.originalDate, 'yyyy-MM-ddThh:mm');
                marketdate.evasiveDate = this.datePipe
                    .transform(marketdate.evasiveDate, 'yyyy-MM-ddThh:mm');
                marketdate.updated = this.datePipe
                    .transform(marketdate.updated, 'yyyy-MM-ddThh:mm');
                marketdate.created = this.datePipe
                    .transform(marketdate.created, 'yyyy-MM-ddThh:mm');
                this.marketdateModalRef(component, marketdate);
            });
        } else {
            return this.marketdateModalRef(component, new Marketdate());
        }
    }

    marketdateModalRef(component: Component, marketdate: Marketdate): NgbModalRef {
        const modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.marketdate = marketdate;
        modalRef.result.then((result) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate/marketdate-popup.service.ts